import React from 'react';
import { change, Field, FieldArray } from 'redux-form';
import LensType from './LensType';
import { connect } from 'react-redux';
import OSGlass from './glass/OSGlass';
import ODGlass from './glass/ODGlass';

const MULTIFOCAL_FOCALITIES = [
  'Bifocal',
  'Trifocal',
  'Multifocal',
  'Progressive Addition Lens',
]

let Glass = props => {
  const { currentStoreOtherDetails, currentEyeglass, member, pprops, pprops: { dispatch },taxSettings } = props;

  const isSegmentHeightRequired = (eyeType) =>
    currentEyeglass?.lens_types_attributes?.some((lens) => {
      if (lens._destroy || !MULTIFOCAL_FOCALITIES.includes(lens.focality)) return false
      return !lens.eye_type || lens.eye_type === eyeType
    })


  const updateCorrespondingAxisValue = (e, member, glassType) => {
    if (["DS", " "].includes(e?.target?.value)) {
      dispatch(change('orderEyeglassForm', `${member}[${glassType}_glass_details][axis]`, null))
    }
  }

  const copyTo = (source, destination) => {
    // let eyeglasses_attributes = currentEyeglassAttributes
    let sourceObj = eval(`${member}.${source}_glass_details`);
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][sphere]`, sourceObj.sphere))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][cylinder]`, sourceObj.cylinder))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][axis]`, sourceObj.axis))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][add]`, sourceObj.add))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][prism]`, sourceObj.prism))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][segment_height]`, sourceObj.segment_height))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][oc_height]`, sourceObj.oc_height))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][base_curve]`, sourceObj.base_curve))
  }

  const renderEyeFieldLabel = (fieldType) => {
    let destination = fieldType === 'od' ? 'os' : 'od'
    return <span>
      Eye
      <small className='text-primary btn-link pointer ml-8' onClick={() => copyTo(fieldType, destination)}>{destination.toUpperCase()}<i className="las la-copy btn-link" /></small>
    </span>
  }
  const TaxField = ({ eyeTestType }) => {
    const lensIndex = currentEyeglass?.lens_types_attributes?.findIndex(
      lens => lens.eye_type === eyeTestType
    );

    const currentLensType =
      lensIndex !== -1
        ? currentEyeglass?.lens_types_attributes?.[lensIndex]
        : null;

    if (
      !currentLensType ||
      currentLensType.tax_percentage === undefined ||
      currentLensType.tax_percentage === null
    ) {
      return null;
    }

    return (
      <div
        className="d-flex align-items-end ml-2 mb-5"
        style={{
          flex: "0 0 auto",
          whiteSpace: "nowrap",
        }}
      >
        <div>
          <label>Tax</label>

          <div className="d-flex align-items-center">
            <Field
              name={`${member}[lens_types_attributes][${lensIndex}][tax_percentage]`}
              type="number"
              component="input"
              className="form-control mr-1"
              style={{ width: "60px" }}
              disabled={!taxSettings.allow_item_tax_override}
              onBlur={() => setTimeout(() => pprops.submit(), 500)}
            />

            <span className="mr-2">%</span>
          </div>
        </div>

        <div>
          <label>Tax amount</label>

          <input
            type="text"
            className="form-control disabled bg-light"
            style={{ width: "80px" }}
            value={
              currentLensType.tax_amount !== undefined &&
              currentLensType.tax_amount !== null
                ? parseFloat(currentLensType.tax_amount).toFixed(2)
                : ""
            }
            readOnly
          />
        </div>
      </div>
    );
  };
  return (
    <div className="col-12 p-6">
      <div className="row">
        {(currentEyeglass.od_stock_lens_amount_on_hand && currentStoreOtherDetails?.stock_lens) ? <span className="badge badge-info badge-pill pointer font-size-14 ml-4 mt-6" style={{ height: 22 }} title='Stock Lens Amount in Hand'>
          {currentEyeglass.od_stock_lens_amount_on_hand}
        </span> : ''}
        {currentStoreOtherDetails?.stock_lens && <>
          <FieldArray
            name={`${member}.lens_types_attributes`}
            props={{
              pprops: pprops,
              member: member,
              currentEyeglass: currentEyeglass,
              eyeTestType: 'od',
              glassModule: true
            }}
            component={LensType}
          />
              <TaxField eyeTestType="od"/>
          <div className="col-12" />
        
        </>}
        <ODGlass
          member={member}
          updateCorrespondingAxisValue={updateCorrespondingAxisValue}
          renderEyeFieldLabel={renderEyeFieldLabel}
          isSegmentHeightRequired={isSegmentHeightRequired('od')}
        />
      </div>

      {currentStoreOtherDetails?.stock_lens && <hr />}

      <div className="row">
        {(currentEyeglass.os_stock_lens_amount_on_hand && currentStoreOtherDetails?.stock_lens) ? <span className="badge badge-info badge-pill pointer font-size-14 ml-4 mt-6" style={{ height: 22 }} title='Stock Lens Amount in Hand'>
          {currentEyeglass.os_stock_lens_amount_on_hand}
        </span> : ''}
        {currentStoreOtherDetails?.stock_lens && <>
          <FieldArray
            name={`${member}.lens_types_attributes`}
            props={{
              pprops: pprops,
              member: member,
              currentEyeglass: currentEyeglass,
              eyeTestType: 'os',
              glassModule: true
            }}
            component={LensType}
          />
            <TaxField eyeTestType="os"/>
          <div className="col-12" />
        </>
        }
        <OSGlass
          member={member}
          updateCorrespondingAxisValue={updateCorrespondingAxisValue}
          renderEyeFieldLabel={renderEyeFieldLabel}
          isSegmentHeightRequired={isSegmentHeightRequired('os')}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { currentStore, storeSetting } = state
  return {
    currentStoreOtherDetails: currentStore.store?.other_details,
     taxSettings:
      storeSetting?.filtered_store_settings?.tax_settings?.[0]?.store_config ||
      {},
  }
}

export default connect(mapStateToProps)(Glass);